<app-base-modal
  [title]="'Элемент товара'"
>
  <mat-tab-group (selectedTabChange)="handleTabChange($event)">
    <mat-tab label="Создать">
      <mat-form-field
        class="field"
        appearance="outline"
      >
        <mat-label>Название</mat-label>
        <input
          matInput
          placeholder="Введите название"
          [(ngModel)]="name"
        >
      </mat-form-field>
    </mat-tab>
    <mat-tab
      label="Изменить"
      [disabled]="!hasDefects"
    >
      <div class="fields">
        <mat-form-field
          appearance="outline"
          class="field"
        >
          <mat-label>Элемент товара</mat-label>
          <mat-select [(ngModel)]="selectedDefect">
            @for (option of productCardDefectDialogData.defects; track option.id) {
              <mat-option [value]="option.id">
                {{option.title}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field
          class="field"
          appearance="outline"
        >
          <mat-label>Название</mat-label>
          <input
            matInput
            placeholder="Введите название"
            [(ngModel)]="name"
            [disabled]="!selectedDefect"
          >
        </mat-form-field>
      </div>
    </mat-tab>
    <mat-tab
      label="Удалить"
      [disabled]="!hasDefects"
    >
      <mat-form-field
        appearance="outline"
        class="field"
      >
        <mat-label>Элемент товара</mat-label>
        <mat-select [(ngModel)]="selectedDefect">
          @for (option of productCardDefectDialogData.defects; track option.id) {
            <mat-option [value]="option.id">
              {{option.title}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </mat-tab>
  </mat-tab-group>
  <div class="buttons-container">
    <button
      mat-button
      class="save-button"
      color="primary"
      [disabled]="isDisabledBtn()"
      (click)="handleBtn()"
    >
      {{ getBtnText() }}
    </button>
    <button
      mat-button
      tabindex="-1"
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
  </div>
</app-base-modal>
